import _ from 'lodash'

import {
  MediaTypeDefaultAttribute,
  MediaTypes,
  MediaTypeViewportAttribute,
  ViewportSlice,
} from 'features/inventory/ad-unit/types/mediaTypes'
import { MediaTypeSchema, MediaTypesSchema, MediaTypeViewportsSchema } from './mediaTypesSchema'

type CommonFields = keyof Pick<
  ViewportSlice,
  'bannerEnabled' | 'bannerSizes' | 'nativeEnabled' | 'playerSize' | 'videoEnabled'
>

const COMMON_FIELDS: CommonFields[] = [
  'bannerEnabled',
  'bannerSizes',
  'nativeEnabled',
  'videoEnabled',
  'playerSize',
]

export const mediaTypeDefaultAttributeToSchema = (
  defaultAttribute: MediaTypeDefaultAttribute,
): MediaTypeSchema => _.pick(defaultAttribute, [...COMMON_FIELDS, 'mediaTypeId', 'updatedAt'])

export const mediaTypeViewportAttributesToSchema = (
  viewportAttributes: MediaTypeViewportAttribute[],
): MediaTypesSchema['viewportAttributes'] =>
  viewportAttributes.map(
    (attribute: MediaTypeViewportAttribute): MediaTypeViewportsSchema => ({
      ...mediaTypeDefaultAttributeToSchema(attribute),
      viewport: {
        ..._.pick(attribute.viewport, [...COMMON_FIELDS, 'minimumWidth', 'name']),
        viewportId: attribute.viewport.id,
      },
      viewportId: attribute.viewport.id,
    }),
  )

export const mediaTypesToSchema = ({
  defaultAttribute,
  kind,
  nativeConfiguration,
  videoConfiguration,
  videoType,
  viewportAttributes,
}: MediaTypes): MediaTypesSchema => {
  const mediaTypesSchema: MediaTypesSchema = {
    defaultAttribute: mediaTypeDefaultAttributeToSchema(defaultAttribute),
    kind,
    nativeConfiguration,
    newViewportId: undefined,
    videoConfiguration,
    videoType,
    viewportAttributes: mediaTypeViewportAttributesToSchema(viewportAttributes),
  }

  return kind === 'default' ? _.omit(mediaTypesSchema, 'newViewportId') : mediaTypesSchema
}
